import React, { useEffect } from "react";
import { Backtotop, Floatinmenu, Underline } from "../../widgets";
import {FaBook} from "react-icons/fa";
import { RadialMenu, Profile_display } from "../../components";
import { librarymenu, libraryOfficers, supportingStaffs } from "../../constants/library";

import "./Library.css";
export default function Library() {
  useEffect(() => {
    document.title = "ACCET-Library";
  }, []);

  const backgroundImage =
    "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/life_at_acgcet/library.webp";

  return (
    <>
      <div className="librarypage">
        <div className="librarybg">
          <div className="libraryheading">Library</div>
          <div className="library_sub_heading">About</div>
        </div>
      </div>
      <section className="librarydark">
        <div className="dept_float_menu">
          <Floatinmenu logo={FaBook} head="Menu" links={librarymenu} />
        </div>
        <RadialMenu menu_links={librarymenu} />
        <div className="library_abt">
          <Underline heading="Overview" />
          <div className="librarytwo-col">
            <p className="library_content">
              The ACGCET Central Library stands as a pillar of academic
              excellence, providing students and faculty with access to a vast
              collection of books, reference materials, and digital resources.
              Entry to the library is granted upon presentation of a valid
              college ID card, ensuring secure and organized access for all
              members. To maintain the sanctity of the space, users are expected
              to leave their bags at the property counter and strictly refrain
              from bringing food or beverages inside. The library is a zone
              dedicated to serious academic pursuits, and members are encouraged
              to make the most of its environment by focusing solely on learning
              and research activities.{" "}
            </p>
            <div className="dept_img_holder">
              <img className="dept_img" src={backgroundImage} />
            </div>
          </div>
          <div className="librarytwo-col1">
            <p className="library_content">
              Reference materials are restricted to in-library use to ensure
              availability for all, and borrowing privileges come with the
              responsibility of timely return. Overdue charges apply to late
              submissions, and any loss or damage to books must be compensated
              as per institutional policies. Users are expected to cooperate
              during exit checks for books and personal belongings. Furthermore,
              the digital library facilities are strictly meant for academic
              purposes, and tampering with library computer systems—including
              installation or uninstallation of software—is prohibited.
              Violations of these rules will attract disciplinary action,
              underscoring the library's commitment to fostering a respectful,
              resource-rich, and academically productive environment.{" "}
            </p>
          </div>
          <Underline heading="Officers Incharge" />
          <Profile_display list_info={libraryOfficers} />
          <Underline heading="Supporting Staffs" />
          <Profile_display list_info={supportingStaffs} />
        </div>
      </section>
      <Backtotop />
    </>
  );
}
